// extracted by mini-css-extract-plugin
module.exports = {"VersionManagerView":"VersionManagerView_VersionManagerView__1y3EZ","assistance":"VersionManagerView_assistance__hpVqE","message":"VersionManagerView_message__1Hvx9"};